const PREFIX = ['platform', 'template'];
export function createTemplateRepository(config) {
    const { repository } = config;
    function getFindQueryKey(props) {
        return [...PREFIX, 'find', props];
    }
    return {
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getFindQueryKey(props),
                async queryFn() {
                    // Static data for now - later will wire up to API
                    const templates = [
                        {
                            id: 'process-mapping-optimization',
                            title: 'Process Mapping & Optimization',
                            description: 'Comprehensive workflow analysis and improvement strategies',
                            summary: 'Streamline operations for peak efficiency',
                            author: 'Oliver',
                            icon: '🎯',
                        },
                        {
                            id: 'genai-implementation',
                            title: 'Getting GenAI Implemented in your Org',
                            description: 'Strategic AI adoption and organizational integration',
                            summary: 'Transform your org with AI',
                            author: 'Arthur',
                            icon: '🤖',
                        },
                        {
                            id: 'tool-stack-cleanup',
                            title: 'Tool Stack Cleanup & Optimization',
                            description: 'Audit and streamline your technology ecosystem',
                            summary: 'Eliminate redundant tools and costs',
                            author: 'Stella',
                            icon: '🧹',
                        },
                        {
                            id: 'critical-intelligence-gathering',
                            title: 'Critical Intelligence Gathering for Project',
                            description: 'Strategic research and competitive intelligence',
                            summary: 'Gather insights that drive decisions',
                            author: 'Quinn',
                            icon: '🔬',
                        },
                        {
                            id: 'rapid-cross-team-fact-finding',
                            title: 'Rapid Cross-Team Fact-Finding',
                            description: 'Fast-track information gathering across departments',
                            summary: 'Uncover facts across your organization',
                            author: 'Nora',
                            icon: '⚡',
                        },
                        {
                            id: 'build-your-own-intelligence-sprint',
                            title: 'Build-Your-Own Intelligence Sprint',
                            description: 'Custom intelligence gathering and analysis framework',
                            summary: 'Create custom intelligence solutions',
                            author: 'Felix',
                            icon: '🏗️',
                        },
                    ];
                    return templates;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=templateRepository.js.map